import React, { useId } from "react";

interface FilePowerpointProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

/**
 * PowerPoint file-type mark: the 2019–2025 Microsoft 365 silhouette
 * (orange circle, darker rounded tile overlapping the left, white P).
 * Original geometry — not Microsoft's SVG paths.
 */
function FilePowerpointIcon({ size = 24, className, ...props }: FilePowerpointProps) {
  const tileFill = `ppt-tile-${useId().replace(/:/g, "")}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={`[&.text-gray-400]:grayscale [&.text-gray-400]:opacity-60 ${className ?? ""}`}
      {...props}
    >
      <defs>
        <linearGradient id={tileFill} x1="6" y1="9" x2="15" y2="22" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#CA4C28" />
          <stop offset="1" stopColor="#B62F14" />
        </linearGradient>
      </defs>
      <rect x="2.6" y="9.15" width="14.3" height="14.3" rx="1.25" fill="#8B2E18" opacity="0.35" />
      <circle cx="17.12" cy="16" r="13" fill="#D35230" />
      <path d="M17.12 3a13 13 0 0 1 13 13h-13Z" fill="#FF8F6B" />
      <path d="M17.12 3a13 13 0 0 0-13 13h13Z" fill="#ED6C47" />
      <rect x="2" y="8.85" width="14.3" height="14.3" rx="1.25" fill={`url(#${tileFill})`} />
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M6.2 12.05h2.85c2.15 0 3.4 1.15 3.4 2.95 0 1.82-1.28 3.1-3.55 3.1H7.72v2.82H6.2V12.05zm1.52 1.38h1.28c1.05 0 1.72.52 1.72 1.57 0 1.08-.67 1.62-1.72 1.62H7.72v-3.19z"
      />
    </svg>
  );
}

export { FilePowerpointIcon };
